module.exports = __webpack_public_path__ + "static/media/Orinocco90.4fd32d04.jpg";